import { render, staticRenderFns } from "./ProjectChooseBeneficiaries.vue?vue&type=template&id=0bc821fa&scoped=true&"
import script from "./ProjectChooseBeneficiaries.vue?vue&type=script&lang=js&"
export * from "./ProjectChooseBeneficiaries.vue?vue&type=script&lang=js&"
import style0 from "./ProjectChooseBeneficiaries.vue?vue&type=style&index=0&id=0bc821fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc821fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
installComponents(component, {VExpandTransition,VFlex,VLayout,VSelect})
